<div
  class="p-grid mu-table-options {{ isMobile ? 'mu-table-options-mobile' : '' }} {{
    showAlways || (tableRowEditor && tableRowEditor.editing) ? 'mu-table-options-show-always' : ''
  }}"
>
  <ng-container [ngSwitch]="optionsModeSwitch">
    <ng-container *ngSwitchCase="optionMode.ROW_EDITING">
      <div class="p-col"></div>
      <div class="p-col mu-saveRowEditing-action" (click)="_rowEditingAction(tableEditingActionsTypes.SAVE_ROW_EDITING)">
        <i class="fas fa-check" aria-hidden="true"></i>
      </div>
      <div class="p-col mu-cancelRowEditing-action" (click)="_rowEditingAction(tableEditingActionsTypes.CANCEL_ROW_EDITING)">
        <i class="fas fa-times" aria-hidden="true"></i>
      </div>
      <div class="p-col"></div>
    </ng-container>
    <ng-container *ngSwitchCase="optionMode.ROW_EDITING_WAITING">
      <div class="p-col"><app-loading [showLoading]="true" type="table"></app-loading></div>
    </ng-container>
    <ng-container *ngSwitchCase="optionMode.NORMAL">
      <div
        *ngFor="let option of isMobileScreen ? baseTableOptionList : tableOptionList"
        class="p-col mu-{{ option.actionType }}-action mu-table-options-action"
        [ngClass]="{
          disabled: isDisabled(option),
          hiden: isHidden(option)
        }"
        [pTooltip]="'tooltip.' + option.actionType | translate"
        tooltipPosition="top"
        (click)="_eventAction(option)"
      >
        <i class="fas fa-{{ option.icon }}" aria-hidden="true"></i>
      </div>
      <div
        class="p-col mu-table-options-menu-action mu-table-options-action mu-position-relative"
        *ngIf="menuActionList.length > 0 && !isMobileScreen"
      >
        <app-mu-popup-menu [actionList]="actions" [menuList]="menuActionList" [position]="menuPosition"></app-mu-popup-menu>
      </div>
    </ng-container>
  </ng-container>
</div>
